export const AGENT_HEADER_CSS = /* css */ `
  /* ── Header ── */
  .lk-widget-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 12px 16px 12px 12px; background: var(--wg-accent-dark); flex-shrink: 0;
  }
  .lk-widget-header-left {
    display: flex; align-items: center; gap: 15px;
  }
  .lk-widget-avatar-btn {
    position: relative;
    border: none; background: none; padding: 0; cursor: default;
  }
  .lk-widget-avatar-btn:not(:disabled) { cursor: pointer; }
  .lk-widget-avatar {
    width: 46px; height: 46px; border-radius: 50%;
    border: 1.6px solid white; object-fit: cover;
    background-color: var(--wg-star-filled);
    transition: box-shadow 0.15s ease;
  }
  .lk-widget-avatar-btn.active .lk-widget-avatar {
    box-shadow: 0 0 0 2px #4ade80;
  }
  .lk-widget-avatar-badge {
    position: absolute; bottom: -2px; right: -2px;
    width: 18px; height: 18px; border-radius: 50%;
    background: #4ade80; color: #000;
    display: flex; align-items: center; justify-content: center;
  }
  .lk-widget-header-text {
    display: flex; flex-direction: column; gap: 5px; color: white;
  }
  .lk-widget-header-name {
    font-size: 16px; font-weight: 700; letter-spacing: -0.32px;
  }
  .lk-widget-header-sub {
    font-size: 14px; font-weight: 400; letter-spacing: -0.168px;
  }
  .lk-widget-header-right {
    display: flex; align-items: center; gap: 7px;
  }
  .lk-widget-expand {
    display: flex; align-items: center; justify-content: center;
    border: none; background: none;
    color: white; cursor: pointer; border-radius: 50%;
    width: 30px; height: 30px; padding: 7.5px;
    transition: background 0.15s ease;
  }
  .lk-widget-expand svg { width: 15px; height: 15px; }
  .lk-widget-expand:hover { background: rgba(255,255,255,0.15); }
  .lk-widget-new-chat {
    display: flex; align-items: center; justify-content: center; gap: 6px;
    border: none; background: none;
    color: white; cursor: pointer; border-radius: 999px;
    min-width: 30px; height: 30px; padding: 0 6.5px;
    transition: background 0.15s ease;
  }
  .lk-widget-new-chat:hover { background: rgba(255,255,255,0.15); }
  .lk-widget-new-chat--armed { background: var(--wg-clay); padding: 0 10px; }
  .lk-widget-new-chat--armed:hover { background: var(--wg-clay); }
  .lk-widget-new-chat-hint { font-size: 12px; font-weight: 600; white-space: nowrap; }
  .lk-widget-close {
    display: flex; align-items: center; justify-content: center;
    border: none; background: none;
    color: white; cursor: pointer; border-radius: 50%;
    width: 24px; height: 24px; padding: 0;
  }
  .lk-widget-close:hover { background: rgba(255,255,255,0.15); }

  /* Hide expand button on mobile — panel is always fullscreen */
  @media (max-width: 768px) {
    .lk-widget-expand { display: none; }
  }
`;
